import { useState } from 'react';
import Overview from './Overview/Overview';
import UserStatTab from './UserStatTab/UserStatTab';
// import OddGames from './OddGames/OddGames';
// import StandardGames from './StandardGames/StandardGames';
import styles from './Stats.module.scss';
import GamesStatTab from './GamesStatTab/GamesStatTab';
import VillagesStatTab from './VillagesStatTab/VillagesStatTab';

const Stats = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const renderTab = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'players':
        return <UserStatTab />;
      case 'oddGames':
        return <GamesStatTab />;
      case 'standard':
        return <VillagesStatTab />;
      default:
        return null;
    }
  };

  return (
    <div className={styles.statsContainer}>
      <nav className={styles.tabs}>
        <button className={activeTab === 'overview' ? styles.active : ''} onClick={() => setActiveTab('overview')}>Vue d'ensemble</button>
        <button className={activeTab === 'players' ? styles.active : ''} onClick={() => setActiveTab('players')}>Joueurs</button>
        <button className={activeTab === 'standard' ? styles.active : ''} onClick={() => setActiveTab('standard')}>Villages</button>
        <button className={activeTab === 'oddGames' ? styles.active : ''} onClick={() => setActiveTab('oddGames')}>Jeux insolites</button>
      </nav>
      <div className={styles.content}>{renderTab()}</div>
    </div>
  );
};

export default Stats;